import {
  MEDIA_REASON_DOWNLOADING,
  MEDIA_REASON_NOT_KEPT,
  MEDIA_REASON_UNAVAILABLE,
  MEDIA_REASON_UNVERIFIED,
} from '@/api/authenticatedMedia';

const labels = {
  [MEDIA_REASON_NOT_KEPT]: 'Not kept for offline use',
  [MEDIA_REASON_DOWNLOADING]: 'Downloading for offline use',
  [MEDIA_REASON_UNAVAILABLE]: 'Unavailable offline',
  [MEDIA_REASON_UNVERIFIED]: 'Could not verify offline copy',
};

export function offlineMediaLabel(result) {
  if (result?.state === 'loading') return 'Loading';
  if (result?.state === 'forbidden') return 'Unable to display';
  return labels[result?.reason] || 'Unavailable offline';
}
